import Repository from "../Repository";

const resource = "/product/retouching-repair";

export default {
  async get(retouching_repair_uuid) {
    return Repository.get(`${resource}/${retouching_repair_uuid}`);
  },

  async getRetouchingRepair(retouching_repair_uuid) {
    return Repository.get(`${resource}/${retouching_repair_uuid}`);
  },

  async createRetouchingRepair(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
